/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import i18n from "i18n";
import { useSelector } from "react-redux";
import { Tooltip, Box } from "@material-ui/core";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import DateFilterDialog from "./DateFilterDialog";
import CalendarTodayRoundedIcon from "@material-ui/icons/CalendarTodayRounded";
import useStyles from "../../CockpitStyleJs/styleFilter";

/**
 *
 * @returns
 */
const DateFilter = () => {
	const { convStartDateFilter, convEndDateFilter, selectedAssistantID } = useSelector(
		state => state.cockpit
	);
	const [openDateFilterDialog, setOpenDateFilterDialog] = useState(false);

	const classes = useStyles();
	const dateSet = convStartDateFilter || convEndDateFilter;

	// Dark mode support
	const muiTheme = useMuiTheme();
	const isDarkMode = muiTheme.palette.type === "dark";
	const activeBackground = isDarkMode ? "var(--dark-selected)" : "rgba(0, 0, 0, 0.12)";
	const iconColorBlack = isDarkMode ? "var(--dark-text-primary)" : "#000000";

	/**
	 * Reset when switching assistantID
	 */
	useEffect(() => {
		setOpenDateFilterDialog(false);
	}, [selectedAssistantID]);

	const handleCloseDateFilterDialog = () => {
		setOpenDateFilterDialog(false);
	};

	return (
		<>
			{/* Filtre Calendrier/date */}
			<Tooltip title={i18n.t("COC.DateFilter")} placement="top">
				<Box className={classes.filterButton} mt={1}>
					<ToggleButtonGroup exclusive size="small">
						<ToggleButton
							value={convStartDateFilter || convEndDateFilter || null}
							type="datetime-local"
							fontSize="small"
							onClick={() => setOpenDateFilterDialog(true)}
							style={
								convStartDateFilter || convEndDateFilter
									? { color: iconColorBlack, background: activeBackground }
									: {}
							}
						>
							<CalendarTodayRoundedIcon fontSize="small" />
						</ToggleButton>
					</ToggleButtonGroup>
				</Box>
			</Tooltip>

			<DateFilterDialog
				handleCloseDateFilterDialog={handleCloseDateFilterDialog}
				openDialog={openDateFilterDialog}
			/>
		</>
	);
};
export default DateFilter;
